import { render, staticRenderFns } from "./Toast.vue?vue&type=template&id=50a20980&scoped=true&lang=pug&"
import script from "./Toast.vue?vue&type=script&lang=js&"
export * from "./Toast.vue?vue&type=script&lang=js&"
import style0 from "./Toast.vue?vue&type=style&index=0&id=50a20980&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a20980",
  null
  
)

export default component.exports